import { render, staticRenderFns } from "./UserMessageDetails.vue?vue&type=template&id=14110875&scoped=true"
import script from "./UserMessageDetails.vue?vue&type=script&lang=js"
export * from "./UserMessageDetails.vue?vue&type=script&lang=js"
import style0 from "./UserMessageDetails.vue?vue&type=style&index=0&id=14110875&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14110875",
  null
  
)

export default component.exports